import React from 'react'

export const COLUMNS = [
  {
    Header: 'Drug Type',
    accessor: 'drugType',
  },
  {
    Header: 'Name',
    accessor: 'genericName',
  },

  {
    Header: 'Upper Limit',
    accessor: 'upperLimit',
    // @ts-ignore
  },
  {
    Header: 'Side Effects',
    accessor: "sideEffects",
    Cell: (row: any) => {
      console.log(row?.value, "value")
      return <span style={{ whiteSpace: 'pre-line' }}>{row.value?.length > 0 ? row.value?.join("\n") : null}</span>
    },
  },
  // {
  //   Header: '',
  //   accessor: 'Edit',
  //   Cell: ({ cell: { } }) => (
  //     <img
  //       className="eye-icon"
  //       src={'assets/images/CRedit.svg'}
  //       width={32}
  //       height={30}
  //       style={{
  //         marginTop: '6px',
  //         paddingRight: '15px',
  //         width: '40px',
  //         height: '40px',
  //       }}
  //       alt="eye"
  //     />
  //   ),
  // },
  // {
  //   Header: '',
  //   accessor: 'Delete',
  //   // @ts-ignore
  //   Cell: ({ cell }) => (
  //     <img
  //       className="eye-icon"
  //       src={'assets/images/CRdelete.svg'}
  //       width={32}
  //       height={30}
  //       style={{
  //         marginTop: '6px',
  //         paddingRight: '15px',
  //         width: '40px',
  //         height: '40px',
  //       }}
  //       alt="eye"
  //     />
  //   ),
  // },
]
